import CustomerModel from "@/models/crm/CustomerModel";
import CrmServiceCollection from "@/collections/CrmServiceCollection";

export default class CustomerCollection extends CrmServiceCollection {
  model() {
    return CustomerModel;
  }

}
